var React = require('react');

function LinkArrowCircled (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z","key":0}),React.createElement("path",{"d":"M12.3285 20.0015H25.0736","strokeWidth":"3","strokeLinecap":"round","key":1}),React.createElement("path",{"d":"M22.3774 26.25L28.2598 20L22.3774 13.75","strokeWidth":"3","strokeLinecap":"round","key":2})]);
}

LinkArrowCircled.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40"};

module.exports = LinkArrowCircled;

LinkArrowCircled.default = LinkArrowCircled;
